<template>
    <a class="btn btn-block btn-success btn-xs align-bottom" :href="url" v-if="!disabled">Bulk Purchase</a>
</template>

<script>
export default {
    name: "BulkPurchaseBtn",
    props: {
        humanStatus: {
            type: String,
            required: true
        }
    },
    computed: {
        disabled() {
            switch (this.humanStatus) {
                case 'human_status_open':
                case 'human_status_waiting_list':
                    return false;

                case 'human_status_closed':
                case 'human_status_full':
                case 'human_status_inactive':
                    return true;

                default:
                    return false;
            }
        },
        url() {
            let path = window.location.href.split('?')[0];
            return `${path}/bookings/bulk`;
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Utility/BulkPurchaseBtn.vue